import React from "react";

const MiniModal = ({ title, message, actions }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[9999]">
      <div className="bg-gray-800 text-white rounded-lg shadow-lg w-full max-w-sm p-6">
        {/* Título */}
        <h2 className="text-2xl font-bold mb-4 text-center text-blue-300">
          {title}
        </h2>

        {/* Mensaje */}
        <p className="text-lg text-gray-200 mb-6 text-center leading-relaxed">
          {message}
        </p>

        {/* Acciones */}
        <div className="flex justify-center space-x-4">
          {actions.map((action, index) => (
            <button
              key={index}
              onClick={action.onClick}
              className={`px-6 py-3 rounded-lg font-bold transition duration-300 text-lg ${
                action.className === "primary"
                  ? "bg-blue-500 hover:bg-blue-600 text-white"
                  : "bg-red-500 hover:bg-red-600 text-white"
              }`}
            >
              {action.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MiniModal;
